import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { gql } from '@reverbdotcom/commons/src/gql';
import { useQuery } from '@reverbdotcom/commons/src/useQuery';
import { RCTextWithIcon, RCTooltip } from '@reverbdotcom/cadence/components';
import { ReverbLogoCircleIcon } from '@reverbdotcom/cadence/icons/react';
import { WalletBalanceQuery } from '@reverbdotcom/commons/src/gql/graphql';
import { parseAmountCents } from '@reverbdotcom/commons/src/money';
import { currencies } from '@reverbdotcom/commons/src/constants';

export default function WalletBalance() {
  const { data, loading } = useQuery<WalletBalanceQuery>(WALLET_BALANCE_QUERY);
  const { walletBalance } = data?.me || {};
  const defaultBalance = parseAmountCents(0, currencies.USD);
  const { amountCents, display } = walletBalance || defaultBalance;

  const amountClass = classNames(
    'earnings-payouts__overview__wallet-balance__amount',
    { 'earnings-payouts__overview__wallet-balance__amount--zero': amountCents === 0 },
  );

  if (loading) {
    return (
      <div className="earnings-payouts__overview__wallet-balance earnings-payouts__overview__wallet-balance--loading"></div>
    );
  }

  return (
    <div className="earnings-payouts__overview__wallet-balance">
      <div className="d-flex fx-justify-between fx-align-center">
        <div>
          <RCTextWithIcon icon={<ReverbLogoCircleIcon />} placement="left" size="large">
            <span className="weight-semibold">{I18n.t('earnings.payouts.walletBalance.title')}</span>
          </RCTextWithIcon>
        </div>
        <RCTooltip text={I18n.t('earnings.payouts.walletBalance.tooltip')} />
      </div>
      <div className={amountClass}>
        {display}
      </div>
    </div>
  );
}

export const WALLET_BALANCE_QUERY = gql(`
  query WalletBalance {
    me {
      _id
      walletBalance {
        amountCents
        display
      }
    }
  }
`);
